import React from 'react';
import styled from 'styled-components'
import { connect } from 'react-redux'
// import actions from '../../redux/actions'
import { Row, Col } from 'antd';

import Layout from '../../components/Layout'
import ProgressBar from '../../components/ProgressBar'
import ButtonComponent from '../../components/Button';

import cameraIcon from '../../assets/images/camera.png'
import signatureIcon from '../../assets/images/signature.png'
import edit from '../../assets/images/edit.png'

import constants from '../../config/constants'

const Main = styled.div`
  padding: 2rem 0;
  overflow-y: scroll;
  scroll-behavior: smooth;
`

const MainRow = styled(Row)`
  margin-top: 1rem;
`

const UploadGrid = styled.div`
  height: 130px;
  border: 1.5px dashed ${constants.color.lightDark};
  width: 98%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
`

const UploadGridRight = styled(UploadGrid)`
  float: right;
`

const UploadBookBank  = styled.div`
  height: 130px;
  border: 1.5px dashed ${constants.color.lightDark};
  width: 48%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
`

const UploadDetail = styled.div`
  text-align: center;

  img {
    width: auto;
    height: 20px;
  }

  p {
    color : ${constants.color.mediumDark};
    font-size : 14px;
    margin: .5rem 0 0;
  }
`

const UploadPicture = styled.div`
  height: 100%;
  width: 100%;
  display: contents;
  margin: 0 auto;
  position: relative;
`

const Picture = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
`

const  SignaturePicture = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;
  z-index: 1;
  display: flex;
  padding: 1rem;
`

const BookBankPicture = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;
  z-index: 1;
  display: flex;
  padding: 1rem;
  transform: rotate(-90deg);
`

const Icon  = styled.div`
  position: absolute;
  top: 7px;
  right: 10px;
  z-index: 2;

  img {
    width: 20px;
    height: auto;
  }
`

const UploadDocument = (props) => {
    const handleSubmit = () => {
      props.history.push('/suitability-test')
    };

    return (
      <Layout title={'แนบเอกสาร'} backIcon={true} onClick={() => props.history.goBack()}>
        <ProgressBar percent={50}/>
        <Main>
          <h5>กรุณาแนบเอกสารและเซ็นชื่อ</h5>
          <MainRow>
            <Col span={12}>
              <h5>รูปบัตรประชาชน</h5>
              <UploadGrid onClick={() => props.history.push('/how-to-id-card')}>
                {
                  props.userInfomations.idCardPicture ?
                  <UploadPicture>
                    <Icon><img src={edit} alt=''/></Icon>
                    <Picture src={props.userInfomations.idCardPicture} alt=''/>
                  </UploadPicture> :
                  <UploadDetail>
                    <img src={cameraIcon} alt=''/>
                    <p>เพิ่มรูป</p>
                  </UploadDetail>
                }
              </UploadGrid>
            </Col>
            <Col span={12}>
              <h5 style={{marginLeft: '0.2rem'}}>ลายเซ็นอิเล็กทรอนิกส์</h5>
              <UploadGridRight onClick={() => props.history.push('/signature')}>
              {
                props.userInfomations.signaturePicture ?
                <UploadPicture>
                  <Icon><img src={edit} alt=''/></Icon>
                  <SignaturePicture src={props.userInfomations.signaturePicture} alt=''/>
                </UploadPicture> :
                <UploadDetail>
                  <img src={signatureIcon} alt=''/>
                  <p>เพิ่มลายเซ็น</p>
                </UploadDetail>
              }
              </UploadGridRight>
            </Col>
          </MainRow>
          <MainRow>
            <Col>
              <h5>หน้าแรกของสมุดบัญชีธนาคาร (ถ้ามี)</h5>
              <UploadBookBank onClick={() => props.history.push('/how-to-book-bank')}>
                {
                  props.userInfomations.bookBankPicture ?
                  <UploadPicture>
                    <Icon><img src={edit} alt=''/></Icon>
                    <BookBankPicture src={props.userInfomations.bookBankPicture} alt=''/>
                  </UploadPicture> :
                  <UploadDetail>
                    <img src={cameraIcon} alt=''/>
                    <p>เพิ่มรูป</p>
                  </UploadDetail>
                }
              </UploadBookBank>
            </Col>
          </MainRow>
        </Main>
        <ButtonComponent
          textcolor={constants.color.white}
          bordercolor={constants.color.orange}
          backgroundcolor={constants.color.orange}
          text={'ทำรายการต่อ'}
          disabled={false}
          onClick={ (props.userInfomations.signaturePicture && props.userInfomations.idCardPicture) && handleSubmit}
          />
      </Layout>
    )
}

const mapStateToProps = (state) => {
  return {
    userInfomations: state.userInfomations
  }
}

const UploadDocumentWithConnect = connect(mapStateToProps, null)(UploadDocument)

export default UploadDocumentWithConnect
